export const formatDuration = (seconds) => {
  if (!seconds) return "0:00";
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins}:${secs.toString().padStart(2, "0")}`;
};

export const formatPercent = (value) => {
  if (value == null) return "-";
  return `${Math.floor(value)}%`;
};

export const formatScore = (score, fallback = "-") => {
  if (score == null) return fallback;
  return `${Math.floor(score)}%`;
};

export const getScoreBadgeClass = (score) => {
  if (score >= 90) return "excellent";
  if (score >= 75) return "good";
  if (score >= 60) return "fair";
  return "poor";
};
